function incrementQuantity(el) {
  if (el.previousElementSibling.value + 1 > el.previousElementSibling.max) {
    return;
  }
  el.previousElementSibling.value++;
  updateQuantity(el);
}
function decrementQuantity(el) {
  el.nextElementSibling.value--;
  updateQuantity(el);
}
function removeLine(el) {
  const id = el.closest(".cart-table-row").dataset.id;
  fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      quantity: 0,
      id: id,
    }),
  }).then((res) => {
    updateCart();
  });
}
function updateQuantity(el) {
  const quantity = el.parentElement.querySelector('input[type="number"]').value;
  if (quantity == 1) {
    el.parentElement.querySelector(".quantity-button").innerHTML =
      '<svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px;">        <path d="M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"></path>    </svg>';
  } else {
    el.parentElement.querySelector(".quantity-button").innerText = "-";
  }
  const id = el.closest("li.cart-table-row").dataset.id;
  fetch(`/cart/change.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      quantity: quantity,
      id: id,
    }),
  }).then((res) => {
    updateCart();
  });
}
function updateCart() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((data) => {
      updateCartNumber(data.item_count);
      updateCartDom(data);
    });
}
function updateCartDom(cart) {
  const formatMoney = document.querySelector("[data-format]").dataset.format;
  const cartItems = document.querySelectorAll(".cart-table-row");
  if (cart.item_count === 0) {
    location.reload();
    return;
  }
  cartItems.forEach((item) => {
    const exists = cart.items.find(
      (cartItem) => cartItem.id == item.dataset.id
    );
    if (!exists) {
      item.remove();
    } else {
      //Item Updates
      //Quantity
      item.querySelector(".quantity-input").value = exists.quantity;
      //Unit Price
      const unitPrice = item.querySelector(".info-price");
      unitPrice.querySelector(".price-current").innerText = Shopify.formatMoney(
        exists.price,
        formatMoney
      );
      if (exists.price != exists.original_price) {
        unitPrice.querySelector(".price-old").innerText = Shopify.formatMoney(
          exists.original_price,
          formatMoney
        );
        unitPrice.querySelector(".price-old").classList.remove("hidden");
      } else {
        unitPrice.querySelector(".price-old").classList.add("hidden");
      }
      //Line Price
      const linePrice = item.querySelector(".total");
      linePrice.querySelector(".current-price").innerText = Shopify.formatMoney(
        exists.line_price,
        formatMoney
      );
      if (exists.price != exists.original_price) {
        linePrice.querySelector(".old-price").innerText = Shopify.formatMoney(
          exists.original_line_price,
          formatMoney
        );
        linePrice.querySelector(".old-price").classList.remove("hidden");
      } else {
        linePrice.querySelector(".old-price").classList.add("hidden");
      }
    }
  });
  //Cart Summary Updates
  const summary = document.querySelector(".cart-summary");
  summary.querySelector(".cart-line-number").innerText = cart.item_count;
  summary.querySelector(".cart-pricing .total-price").innerText =
    Shopify.formatMoney(cart.total_price, formatMoney);
  summary.querySelector(".cart-pricing .discount-amount").innerText =
    Shopify.formatMoney(cart.total_discount, formatMoney);
  if (cart.total_discount > 0) {
    summary
      .querySelector(".cart-pricing .cart-discounts")
      .classList.remove("hidden");
  } else {
    summary
      .querySelector(".cart-pricing .cart-discounts")
      .classList.add("hidden");
  }
  //Note Updates
  document.querySelector(".cart-note-input").value = cart.note;
}
function clearCart() {
  fetch(`/cart/clear.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => {
    updateCart();
  });
}
function saveNote() {
  const noteElement = document.querySelector(".cart-note-input");
  fetch(`/cart/update.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      note: noteElement.value,
    }),
  }).then((res) => {
    updateCart();
  });
}

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
  };